import PropTypes from 'prop-types';

const TagAdd = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M6.037 1.25a7.6 7.6 0 0 0 0 1.5H2.835a.085.085 0 0 0-.085.085v6.684a1.25 1.25 0 0 0 .367.884l6.584 6.577a.92.92 0 0 0 1.004.2.9.9 0 0 0 .298-.2l5.986-5.986A.92.92 0 0 0 16.99 9.7L15.5 8.21a6.5 6.5 0 0 0 1.227-.894l1.326 1.327a2.42 2.42 0 0 1 0 3.412l-.002.002-5.985 5.984a2.42 2.42 0 0 1-3.424 0l-6.584-6.575A2.75 2.75 0 0 1 1.25 9.52V2.835c0-.875.71-1.585 1.585-1.585z"
            fill={color}
        />
        <path d="M6.184 5.424a.75.75 0 1 1 0 1.5h-.01a.75.75 0 1 1 0-1.5z" fill={color} />
        <path
            d="M12 .25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V7a.75.75 0 0 1-1.5 0V4.75H9a.75.75 0 0 1 0-1.5h2.25V1A.75.75 0 0 1 12 .25"
            fill={color}
        />
    </svg>
);

export default TagAdd;

TagAdd.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
